export default {
  userCount: (state) => {
    console.log(state);
    return state.userStatus * 10;
  }
}
